import React from "react";
//import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";

function FAQPage() {
  return (
    <div>
      <Navbar />
      <h1 className="text-red-300 text-3xl font-bold underline">
        This is the FAQ Page
      </h1>
    </div>
  );
}

export default FAQPage;
